module.exports = __webpack_public_path__ + "fonts/VetoSans-Medium_1.ccdce5d0.woff";